import React, { Component } from 'react';

const defaultOptions = {
  minValue: 0, maxValue: 5, minLabel: 0, maxLabel: 5
};

const styles = {
  container: {
    width: '100%',
    padding: '8px 0',
  },
  buttonsRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    border: '2px solid #ccc',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    color: '#333',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    transition: 'all 0.15s ease',
  },
  buttonSelected: {
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    border: '2px solid #333',
    background: '#333',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    transition: 'all 0.15s ease',
  },
  labelsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '8px',
    fontSize: '0.7em',
  },
};

export class LinearScaleAnswer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentWillUnmount() {
    if (this.props && this.props.clearSurvey) {
      this.props.clearSurvey();
    }
  }

  render() {
    const { question, answer } = this.props;
    const options = {
      ...defaultOptions
    };
    if (question.options !== undefined) {
      options.minLabel = (question.options.minLabel !== undefined && question.options.minLabel.length > 0) ? question.options.minLabel : question.options.minValue;
      options.minValue = question.options.minValue || 0;
      options.maxLabel = (question.options.maxLabel !== undefined && question.options.maxLabel.length > 0) ? question.options.maxLabel : question.options.maxValue;
      options.maxValue = question.options.maxValue || 5;
    }

    const values = [];
    for (let i = options.minValue; i <= options.maxValue; i++) {
      values.push(i);
    }

    return (
      <div style={styles.container}>
        <div style={styles.buttonsRow}>
          {values.map((value) => (
            <button
              key={value}
              type="button"
              style={answer.answer === value ? styles.buttonSelected : styles.button}
              onClick={() => this.props.onChange(value)}
              aria-label={`${value}`}
            >
              {value}
            </button>
          ))}
        </div>
        <div style={styles.labelsRow}>
          <span>{options.minLabel}</span>
          <span>{options.maxLabel}</span>
        </div>
      </div>
    );
  }
}

export default LinearScaleAnswer;
